export function ErrorPage() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 836 507" fill="none">
      <path
        fill="#393A40"
        fillRule="evenodd"
        d="M836 505.824c0-.381-1.056-.69-2.356-.69H2.356c-1.3 0-2.356.309-2.356.69v.12c0 .381 1.056.69 2.356.69h831.288c1.3 0 2.356-.309 2.356-.69v-.12Z"
        clipRule="evenodd"
      />
      <path
        fill="#0C1B24"
        fillRule="evenodd"
        d="M23.332 505.134s-71.494-98.848 52.09-188.045c76.53-55.235 11.343-108.914 11.343-180.527 0-92.074 99.271-153.13 179.93-131.667 105.056 27.957 127.18 104.56 251.804 23.914C636.801-47.745 765.971 47.09 730.937 151.337c-72.902 216.921 159.696 123.827 69.023 353.796H23.332v.001Z"
        clipRule="evenodd"
      />
      <path
        fill="#055478"
        fillRule="evenodd"
        d="M126.888 494.027H33.876c-2.825 0-5.119 2.475-5.119 5.523 0 3.049 2.294 5.524 5.12 5.524h126.396c.417.006.826-.043 1.219-.142l.004-.001.009-.002a4.983 4.983 0 0 0 2.195-1.215l.01-.01.007-.006.006-.007.01-.009a5.524 5.524 0 0 0 1.398-2.193l.004-.009.001-.004a5.88 5.88 0 0 0 .31-1.57v-.002a5.896 5.896 0 0 0-.121-1.6l-.001-.005-.002-.009a5.683 5.683 0 0 0-1.126-2.368l-.009-.011-.006-.007-.006-.007-.008-.011a5.123 5.123 0 0 0-2.033-1.509l-.008-.003-.004-.002a4.807 4.807 0 0 0-1.188-.308c-32.663-4.57-39.331-19.236-47.256-32.752-4.703-8.022-9.855-15.622-19.346-21.3-9.014-5.392-22.132-9.08-43.151-9.181l.023-.032c1.084-1.391 2.615-2.856 4.544-4.34 8.8-6.765 25.173-13.363 47.598-13.363 5.621 0 9.558-.597 12.15-1.53 2.866-1.032 4.595-2.6 5.617-4.223 1.469-2.33 1.843-5.078.869-8.23-1.102-3.569-4.822-8.334-9.881-13.458-4.537-4.594-10.137-9.726-15.002-14.953-3.125-3.359-5.944-6.739-7.843-10.043-1.335-2.323-2.304-4.492-1.981-6.578.164-1.059.761-2.004 1.71-2.927 1.56-1.518 3.875-2.833 7.02-4.055 18.501-7.184 30.797-5.004 40.252-5.254 5.973-.159 11.014-1.205 15.735-4.66 4.444-3.251 8.704-8.791 12.977-18.588 5.804-13.306 11.265-20.882 18.037-24.885 4.96-2.932 10.549-3.89 17.238-4.119 7.488-.257 16.231.431 26.806.888 2.823.122 5.207-2.252 5.32-5.298.113-3.046-2.087-5.618-4.91-5.74-22.677-.981-37.468-2.457-49.373 4.58-8.234 4.868-15.325 13.692-22.382 29.87-3.766 8.634-7.1 13.12-11.153 15.197-4.166 2.134-8.833 1.789-14.609 1.673-9.383-.188-21.215-.345-37.405 5.942-9.102 3.535-13.348 8.435-14.856 13.35-1.51 4.925-.487 10.415 2.643 16.021 3.585 6.419 10.076 13.23 16.534 19.555 5.032 4.929 10.016 9.555 13.172 13.481.523.651 1.06 1.489 1.478 2.187a8.409 8.409 0 0 1-.689.178c-1.871.388-4.332.572-7.474.572-24.743 0-42.861 7.47-52.902 14.932-5.014 3.727-8.161 7.621-9.562 10.753-1.858 4.157-1.307 7.707.488 10.231 1.474 2.072 4.275 3.908 8.905 3.908 19.092 0 30.992 2.955 39.093 7.8 7.751 4.637 11.817 10.994 15.658 17.544 5.516 9.408 10.509 19.289 21.862 26.81Z"
        clipRule="evenodd"
      />
      <path
        fill="#004564"
        fillRule="evenodd"
        d="M242.255 263.738a2.4 2.4 0 0 0-2.4-2.4h-25.199a2.4 2.4 0 0 0-2.4 2.4v41.517a2.4 2.4 0 0 0 2.4 2.4h25.199a2.4 2.4 0 0 0 2.4-2.4v-41.517Z"
        clipRule="evenodd"
      />
      <path
        fill="#C3EEFF"
        fillRule="evenodd"
        d="M350.092 215.578s-44.087-2.35-54 0c-12.354 2.928-39.979 20.994-52.606 29.551a14.902 14.902 0 0 0-6.521 12.321l-.001 54.094a14.9 14.9 0 0 0 6.522 12.321c12.627 8.557 40.252 26.623 52.606 29.551 9.913 2.35 54 0 54 0V215.578Z"
        clipRule="evenodd"
      />
      <path
        fill="#009CFE"
        fillOpacity=".275"
        fillRule="evenodd"
        d="M236.967 258.319c1.822-2.18 4.467-5.105 7.15-7.233 6.492-5.149 46.325-29.126 54.646-29.126h51.331v-6.382s-44.087-2.35-54 0c-12.354 2.928-39.98 20.994-52.606 29.552a14.9 14.9 0 0 0-6.521 12.32v.869Z"
        clipRule="evenodd"
      />
      <path
        fill="#0D7DAF"
        d="M350.092 353.415v-8.708s-39.118 3.231-51.12 0c-12.002-3.231-41.522-19.728-41.522-19.728l-20.486-14.599v1.163a14.9 14.9 0 0 0 6.522 12.321c12.627 8.557 40.252 26.623 52.606 29.551 9.913 2.35 54 0 54 0ZM304.939 292.175a7.679 7.679 0 1 0 0-15.358 7.679 7.679 0 0 0 0 15.358Z"
      />
      <path
        fill="#005074"
        fillRule="evenodd"
        d="M431.192 244.959a7.402 7.402 0 0 0-7.401-7.401h-66.169v14.802h66.169a7.4 7.4 0 0 0 7.401-7.4v-.001ZM431.192 324.034a7.402 7.402 0 0 0-7.401-7.401h-66.169v14.802h66.169a7.4 7.4 0 0 0 7.401-7.4v-.001Z"
        clipRule="evenodd"
      />
      <path
        fill="#0D7DAF"
        fillRule="evenodd"
        d="M370.169 210.848a3.767 3.767 0 0 0-3.764-3.765h-17.568a3.767 3.767 0 0 0-3.764 3.765v147.297a3.767 3.767 0 0 0 3.764 3.765h17.568a3.767 3.767 0 0 0 3.764-3.765V210.848Z"
        clipRule="evenodd"
      />
      <path
        fill="#004564"
        fillRule="evenodd"
        d="M370.169 358.145V340.86h-25.096v17.285a3.766 3.766 0 0 0 3.764 3.764h17.568a3.766 3.766 0 0 0 3.764-3.764Z"
        clipRule="evenodd"
      />
      <path
        fill="#009CFE"
        fillOpacity=".275"
        fillRule="evenodd"
        d="M345.075 210.848v12.398h25.097v-12.398a3.767 3.767 0 0 0-3.764-3.765H348.84a3.767 3.767 0 0 0-3.765 3.765Z"
        clipRule="evenodd"
      />
      <path
        fill="#055478"
        fillRule="evenodd"
        d="M752.886 443.81a5.23 5.23 0 0 0 1.877 1.806c2.826 1.585 5.358 3.463 7.006 4.778l-.219.087c-2.852 1.04-6.714 1.913-11.121 2.835-10.265 2.149-23.266 4.488-34.134 8.872-8.032 3.24-14.921 7.65-19.24 13.573-2.789 3.824-3.616 7.325-3.338 10.326.288 3.11 1.747 5.956 4.481 8.359 2.764 2.431 7.138 4.492 12.658 6.011 26.284 7.236 81.451 3.804 81.451 3.804 2.82-.18 4.973-2.773 4.804-5.787-.168-3.014-2.595-5.314-5.415-5.134 0 0-53.025 3.476-78.286-3.478-2.84-.781-5.289-1.682-7.176-2.788-1.11-.65-2.092-1.133-2.325-2.044-.201-.784.46-1.5 1.221-2.544 6.041-8.283 18.77-12.088 30.954-14.967 14.076-3.326 27.68-5.328 32.982-8.668 3.024-1.906 4.4-4.393 4.674-6.877.199-1.812-.135-3.857-1.516-6.046-1.382-2.192-4.444-5.013-9.845-8.326a5.233 5.233 0 0 0-1.698-1.619c-5.953-3.513-10.094-6.8-12.726-10.011-1.968-2.4-2.984-4.627-3.045-6.849-.062-2.242.809-4.365 2.088-6.477 1.679-2.771 4.072-5.451 6.748-8.116 8.339-8.308 19.131-16.426 24.125-24.84 6.647-11.198 7.576-20.805 5.2-28.374-2.293-7.308-7.759-13.003-15.277-16.544-10.059-4.737-23.949-5.585-37.457-1.556-5.363 1.6-12.437 5.221-20.56 7.391-10.855 2.9-23.807 2.916-36.841-10.346-10.158-10.335-13.012-22.117-17.745-31.039-2.946-5.552-6.504-10.17-11.917-13.359-5.165-3.043-12.141-4.818-22.304-4.382-2.823.121-5.023 2.668-4.91 5.685.113 3.017 2.497 5.368 5.32 5.247 9.108-.39 14.874 1.15 18.891 4.369 4.075 3.265 6.294 8.065 8.665 13.389 3.901 8.759 7.921 18.837 16.94 28.014 16.411 16.698 32.716 16.688 46.384 13.036 8.227-2.198 15.398-5.846 20.83-7.466 11.023-3.289 22.366-2.837 30.575 1.029 4.661 2.195 8.277 5.48 9.699 10.011 1.606 5.116.354 11.466-4.138 19.034-4.608 7.764-14.766 15.032-22.461 22.697-7.245 7.217-12.308 14.953-12.089 22.918.202 7.327 4.76 15.734 18.21 24.366Z"
        clipRule="evenodd"
      />
      <path
        fill="#004564"
        fillRule="evenodd"
        d="M601.255 265.832a2.401 2.401 0 0 1 2.399-2.401h25.2c1.324 0 2.4 1.076 2.4 2.401v41.517a2.401 2.401 0 0 1-2.4 2.399h-25.2a2.4 2.4 0 0 1-2.399-2.399v-41.517Z"
        clipRule="evenodd"
      />
      <path
        fill="#C3EEFF"
        fillRule="evenodd"
        d="M493.415 217.671s44.087-2.35 54.001 0c12.354 2.928 39.979 20.994 52.605 29.552a14.9 14.9 0 0 1 6.521 12.32l.001 54.094c0 4.933-2.442 9.547-6.521 12.321-12.627 8.557-40.252 26.623-52.606 29.551-9.914 2.35-54.001 0-54.001 0V217.671Z"
        clipRule="evenodd"
      />
      <path
        fill="#009CFE"
        fillOpacity=".275"
        fillRule="evenodd"
        d="M493.415 219.178v-1.507s44.087-2.35 54.001 0c12.354 2.928 39.979 20.994 52.605 29.552a14.9 14.9 0 0 1 6.521 12.32v3.893l-5.288-8.455c-3.906-6.246-49.524-27.702-56.313-29.642-6.79-1.94-48.343 0-48.343 0l-3.183-6.161Z"
        clipRule="evenodd"
      />
      <path
        fill="#0D7DAF"
        d="M606.543 313.638c0 4.933-2.442 9.547-6.521 12.321-12.627 8.557-40.252 26.623-52.606 29.551-9.914 2.35-54.001 0-54.001 0v-8.912c10.845.626 45.198 2.412 54.001.465 10.494-2.32 39.006-19.062 43.315-22.212l15.812-11.213ZM547.296 294.27a7.678 7.678 0 1 0 0-15.357 7.679 7.679 0 0 0 0 15.357Z"
      />
      <path
        fill="#0D7DAF"
        fillRule="evenodd"
        d="M498.434 212.943a3.765 3.765 0 0 0-3.764-3.764h-17.568a3.766 3.766 0 0 0-3.764 3.764v147.298a3.766 3.766 0 0 0 3.764 3.764h17.568a3.765 3.765 0 0 0 3.764-3.764V212.943Z"
        clipRule="evenodd"
      />
      <path
        fill="#004564"
        fillRule="evenodd"
        d="M498.435 360.241v-17.285h-25.097v17.285a3.767 3.767 0 0 0 3.764 3.765h17.568a3.767 3.767 0 0 0 3.765-3.765Z"
        clipRule="evenodd"
      />
      <path
        fill="#009CFE"
        fillOpacity=".275"
        fillRule="evenodd"
        d="M473.338 212.943v12.398h25.097v-12.398a3.767 3.767 0 0 0-3.765-3.765h-17.567a3.767 3.767 0 0 0-3.765 3.765Z"
        clipRule="evenodd"
      />
      <path
        fill="#C3EEFF"
        fillRule="evenodd"
        d="m484.245 386.363-7.32 29.95 16.449-4.284 9.331 19.448-3.385-29.487-13.171 4.772-1.904-20.399ZM361.216 144.217l-1.22 30.754 15.405-7.436 13.136 17.193-9.273-28.19-12.066 7.267-5.982-19.588ZM393.235 371.631l.827 21.667-10.436-5.238-8.899 12.113 6.282-19.861 8.173 5.12 4.053-13.801ZM522.095 164.473l.865 20.968-10.933-5.07-9.322 11.723 6.581-19.22 8.563 4.954 4.246-13.355Z"
        clipRule="evenodd"
      />
      <path
        fill="#173E34"
        fillRule="evenodd"
        d="M132.582 505.134c0-11.417-11.254-24.461-28.745-14.622 10.984-16.856-17.786-35.844-33.48-15.594-7.741-17.69-38.375-11.577-33.919 10.644-12.26-10.644-33.324 3.142-23.994 19.572h120.138ZM699.736 505.134c0-11.417 11.338-24.461 28.96-14.622-11.067-16.856 17.92-35.844 33.732-15.594 7.799-17.69 38.664-11.577 34.174 10.644 12.353-10.644 33.575 3.142 24.174 19.572h-121.04Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
